import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { useLang } from "../i18n";
import { Shell } from "../layout";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");
  const { t } = useLang();

  useEffect(() => {
    if (!sessionId) return setStatus("unknown");
    let tries = 0;
    const poll = async () => {
      try {
        const r = await fetch(`${API}/payments/status/${sessionId}`);
        if (r.ok) {
          const data = await r.json();
          if (data.payment_status === "paid") return setStatus("paid");
        }
      } catch { /* retry */ }
      if (++tries < 15) setTimeout(poll, 2000);
      else setStatus("pending");
    };
    poll();
  }, [sessionId]);

  const copy = status === "paid"
    ? [t("pay.receivedA"), t("pay.receivedB"), t("pay.receivedCopy")]
    : status === "checking"
      ? [t("pay.checkingA"), t("pay.checkingB"), t("pay.checkingCopy")]
      : [t("pay.almostA"), t("pay.almostB"), t("pay.almostCopy")];

  return (
    <Shell>
      <main className="admin-login">
        <div className="login-card" data-testid="payment-success-page">
          <span className="brand-mark">NN</span>
          <p className="eyebrow">{t("pay.eyebrow")}</p>
          <h1>{copy[0]}<br /><em>{copy[1]}</em></h1>
          <p className="payment-copy">{copy[2]}</p>
          <Link to="/account" className="button button-red full" data-testid="payment-success-account-link">{t("pay.goGarage")}</Link>
        </div>
      </main>
    </Shell>
  );
}

export function PaymentCancel() {
  const { t } = useLang();
  return (
    <Shell>
      <main className="admin-login">
        <div className="login-card" data-testid="payment-cancel-page">
          <span className="brand-mark">NN</span>
          <p className="eyebrow">{t("pay.eyebrow")}</p>
          <h1>{t("pay.cancelA")}<br /><em>{t("pay.cancelB")}</em></h1>
          <p className="payment-copy">{t("pay.cancelCopy")}</p>
          <Link to="/account" className="button button-red full" data-testid="payment-cancel-account-link">{t("pay.goGarage")}</Link>
        </div>
      </main>
    </Shell>
  );
}
